import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';

import FormListItem from './formListItem';
import shapes from '../../common/shapes';
import Spinner from '../../common/spinner';
import Loader from '../../common/loader';

import './formList.css';

class FormList extends Component {
  componentDidMount() {
    const {
      onFormListInitialize,
      token
    } = this.props;

    onFormListInitialize(token);
  }

  handleEditForm = (formId) => {
    const {
      history
    } = this.props;

    const formUrl = `/edit/${formId}`;

    history.push(formUrl);
  };

  handleViewForm = (formLink) => {
    window.open(formLink, '_newtab');
  };

  handleNewForm = () => {
    const {
      token,
      onNewForm
    } = this.props;

    onNewForm(token);
  };

  createFormListContent = (forms) => {
    const formListItems = forms.map(form => (
      <FormListItem
        key={form.id}
        form={form}
        onViewForm={this.handleViewForm}
        onEditForm={this.handleEditForm}
      />
    ));
  
    return formListItems;
  };

  render() {
    const {
      isInitializing,
      forms,
      isCreatingForm,
      newFormId
    } = this.props;

    const emptyFormList = (
      <div className="empty-forms-list-container">
        <img src="https://cdn.workast.io/integrations/Forms/screen-demo.png" className="demo" alt="Forms in Workast" />
        <span className="empty-text">
          Use forms to capture team requests and create tasks in this space
          <br />
          Try&nbsp;
          <code>/forms</code>
          &nbsp;in Slack
        </span>
        <button
          type="button"
          onClick={this.handleNewForm}
          disabled={isCreatingForm}
          className="btn btn-success"
        >
          Create Form
          <Spinner isLoading={isCreatingForm} />
        </button>
      </div>
    );

    const content = forms.length === 0 ? emptyFormList : this.createFormListContent(forms);

    return (
      <div>
        { newFormId && <Redirect to={`/edit/${newFormId}`} /> }
        <div className="row topbar-container">
          <div className="col-xs-10 col-lg-11 text-left">
            <h1 className="topbar-header">
              Forms in this space
            </h1>
          </div>
          <div className="col-xs-2 col-lg-1 text-right">
            <button
              type="button"
              onClick={this.handleNewForm}
              disabled={isCreatingForm}
              className="btn btn-success btn-block"
            >
              Create
              <Spinner isLoading={isCreatingForm} />
            </button>
          </div>
        </div>
        <div className="row form-list-container">
          <div className="col-xs-12">
            {isInitializing ? <Loader /> : content}
          </div>
        </div>
      </div>
    );
  }
}

FormList.propTypes = {
  isInitializing: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  forms: PropTypes.arrayOf(PropTypes.shape(shapes.form)).isRequired,
  isCreatingForm: PropTypes.bool.isRequired,
  onFormListInitialize: PropTypes.func.isRequired,
  onNewForm: PropTypes.func.isRequired,
  newFormId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired
};

export default withRouter(FormList);
